import React, { useState, useEffect } from "react";


import bg from "./content/pics/bg.jpg";
import logo from "./content/pics/logo.jpeg";
import "./landing.css"; // Import the CSS file

const quotes = [
  "  “You can never get a cup of tea large enough or a book long enough to suit me.”C.S. Lewis ",
  " “Reading is the sole means by which we slip, involuntarily, often helplessly, into another’s skin, another’s voice, another’s soul.” — Joyce Carol Oates",
  " “No matter how busy you may think you are, you must find time for reading, or surrender yourself to self-chosen ignorance.” — Confucius",
  " “A word after a word after a word is power.” – Margaret Atwood",
  " “Today a reader, tomorrow a leader. –”Margaret Fuller",
];

function LandingPage() {
  const [quoteIndex, setQuoteIndex] = useState(0);
  const [typedText, setTypedText] = useState("");
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
      setTypedText("");
      setIsTypingComplete(false);
    }, 20000); // Change quotes every 10 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const quoteText = quotes[quoteIndex];
    let currentIndex = 0;

    const typingInterval = setInterval(() => {
      setTypedText((prevTypedText) => prevTypedText + quoteText[currentIndex]);
      currentIndex++;

      if (currentIndex === quoteText.length) {
        clearInterval(typingInterval);
        setIsTypingComplete(true);
      }
    }, 70); // Typing speed (milliseconds per character)

    return () => clearInterval(typingInterval);
  }, [quoteIndex]);

  return (
    <div className="landing-page">
      <div className="bg-container">
        <img src={bg} alt="Background" className="bg-image" />
        <div className="quote-container">
          {isTypingComplete ? (
            <p className="quote-text">{quotes[quoteIndex]}</p>
          ) : (
            <p className="quote-text">{typedText}</p>
          )}
        </div>
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
          <div className="links-container">
            <a href="/">Home</a>
            <a href="/content">Content</a>
            <a href="/aboutus">About Us</a>
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default LandingPage;
